// extracted by mini-css-extract-plugin
module.exports = {"lia-type":"OccasionType_lia-type__hWif3"};